export const PORTFOLIO_BOARD_CONFIG = {
    name            : 'Board',
    menuName        : 'Board',
    icon            : 'i5-board',
    // iconLight       : 'i5-board-light',
    image           : 'board',
    iconSvg         : 'isvg-view-board',
    url             : 'board',
    stringId        : 'board',
    description     : 'Advanced Kanban board with multiple grouping options and project hierarchy support.',
    customViewName  : 'Board',
}
